const basicAccount = {
  id: '',
  adminComments: '',
  clientType: '',
  comments: '',
  contactsAttributes: [],
  executiveManagerId: '',
  industry: {},
  industryId: '',
  insuranceBrokerId: '',
  isNonWantedClient: false,
  isVip: false,
  legalPersonType: 'natural',
  name: '',
  nationalIdentification: '',
  primaryContact: {}
};

export default basicAccount;
